import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Hooks/useForm";
import { toastShow } from "../../../Services/ToastService";
import Loader from "../../../Components/Loader/Loader";
import { getAreas } from "../../../../API/Global/Areas/AreasRequests";
import { getMarcas } from "../../../../API/IT/MarcaProducto/MarcaProductoRequest";
import { getEstadosDispositivos } from "../../../../API/Global/Status/StatusRequests";
import { getTipoDispositivo } from "../../../../API/IT/TipoDispositivos/TipoDispositivoRequest";
import { editarRed, getClaseRed, getPersonal, getTipoRed, guardarRed } from "../../../../API/IT/DireccionesIP/DireccionesIPRouter";
import { getDateTimeStringSQL } from "../../../Services/Moment/Luxon";
import { Chips } from "primereact/chips";
import { Checkbox } from "primereact/checkbox";

const RedCRUD = ({
    red,
    toastRef,
    showDialog,
    setShowDialog,
    selected,
    getInfo,
    modo,
}) => {

  const [show, setShow] = useState(false);
  const [areas, setAreas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [tipoRed, setTipoRed] = useState([]);
  const [claseRed, setClseRed] = useState([]);
  const [personal, setPersonal] = useState([]);


  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdDireccionIP: selected?.IdDireccionIP ? selected?.IdDireccionIP : -1,
    IdStatus: selected ? selected?.IdStatus : 3480,
    FechaCreado: new Date(),
    FechaModificado: new Date(),
    IdMarca: selected ? selected?.IdMarca : null,
    IdArea: selected ? selected?.IdArea : null,
    UsaAntivirus: selected ? selected?.UsaAntivirus : null
  };



  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);


  const getValoresIniciales = async () => {
    setLoading(true);

    const areaTempo = await getAreas();
    setAreas(areaTempo);

    const marca = await getMarcas();
    setMarcas(marca);

    const estadosTempo = await getEstadosDispositivos();
    setEstados(estadosTempo);

    const tipoDispositivoTempo = await getTipoDispositivo();
    setTipoDispositivos(tipoDispositivoTempo);

    const tipoRedTempo = await getTipoRed();
    setTipoRed(tipoRedTempo);

    const claseRedTempo = await getClaseRed();
    setClseRed(claseRedTempo);

    const personalTempo = await getPersonal();
    setPersonal(personalTempo);

    const areaInicial = modo === "Crear" ? "" : areaTempo.find((a) => a.IdArea === selected?.IdArea);
    const marcaInicial = modo === "Crear" ? "" : marca.find((m) => m.IdMarca === selected?.IdMarca);
    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo?.find((m) => m.IdStatus === values?.IdStatus);
    const tipoDisp = modo === "Crear" ? "" : tipoDispositivoTempo.find((m) => m.IdTipoDispositivo === selected?.IdTipoDispositivo);
    const tipoR = modo === "Crear" ? "" : tipoRedTempo.find((m) => m.IdTipoRed === selected?.IdTipoRed);
    const claseR = modo === "Crear" ? "" : claseRedTempo.find((m) => m.IdClase === selected?.IdClase);
    const personalD = modo === "Crear" ? "" : personalTempo.find((m) => m.IdPersonalIPS === selected?.IdPersonalIPS);


    setValues({
      ...selected,
      IdDireccionIP: selected?.IdDireccionIP ? selected?.IdDireccionIP : -1,
      Areas: areaInicial,
      Marcas: marcaInicial,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      TipoDispositivo: tipoDisp,
      TipoRedes: tipoR,
      ClaseRed: claseR,
      PersonalD: personalD,
      FechaCreado: new Date(),
      FechaModificado: new Date(),
      Correos: selected?.Correos ? selected.Correos.split(",").map((c) => c.trim()): [],
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreDispositivo) {
        error.NombreDispositivo = true;
        error.error = true;
    }  

    setError(error);
    return error;
  };

  // const verificarDuplicado = () => {
  //   const duplicado = red.find(
  //     (r) => r.IdDireccionIP !== values.IdDireccionIP && r?.DireccionIP === values.DireccionIP
  //   );

  //   if (duplicado) {
  //     let mensaje = "Ya existe una red con el mismo valor de: ";
  //     if (duplicado.DireccionIP === values?.DireccionIP) mensaje += `IP ${duplicado.DireccionIP}`;
  //     return mensaje;
  //   }

  //   return null;
  // };

  const agregarRuta = async () => {
    const e = verificarInfo();

    if (e.error) {
      toastShow(toastRef, "error", "Error", "Campos requeridos");
      return;
    }

    if (!e.error) {
    //   const duplicado = verificarDuplicado();

    //   if (duplicado) {
    //     toastShow(toastRef, "error", "Error", duplicado);
    //     return;
    //   }

      const Datos = {
        IdDireccionIP: values?.IdDireccionIP,
        DireccionIP: values?.DireccionIP,
        NombreDispositivo: values?.NombreDispositivo,
        IdTipoDispositivo: values?.TipoDispositivo?.IdTipoDispositivo,
        IdTipoRed: values?.TipoRedes?.IdTipoRed,
        IdClase: values?.ClaseRed?.IdClase,
        IdMarca: values?.Marcas?.IdMarca,
        Modelo: values?.Modelo,
        Serie: values?.Serie,
        IdArea: values?.Areas?.IdArea,
        AnyDesk: values?.AnyDesk,
        ClaveAnydesk: values?.ClaveAnydesk,
        IdPersonalIPS: values?.PersonalD?.IdPersonalIPS,
        FechaCreado: getDateTimeStringSQL(new Date(values?.FechaCreado)),
        FechaModificado: getDateTimeStringSQL(new Date(values?.FechaModificado)),
        IdStatus: values?.Estado?.IdStatus,
        Comentarios: values?.Comentarios,
        Correos: Array.isArray(values?.Correos) ? values.Correos.join(",") : "",
        UsaAntivirus: values?.UsaAntivirus ? 1 : 0,
      }

      if (Datos.IdDireccionIP > 0) {
        setLoading(true);
        const resultado = await editarRed(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Editados",
            resultado[0]?.MENSAJE
          );
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRed(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setShow(false);
  };

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarRuta();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const dialogTitle = modo === "Crear" ? "Agregar Red" : "Editar Red";

  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor2"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "50%", margin: "auto" }}

      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>

            <Toast ref={toastRef}/>

            <div className="modal__input-contenedor3 gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="DireccionIP"
                    value={values.DireccionIP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IP ? "p-invalid" : ""}
                  />
                  <label htmlFor="IP">Dirección IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="NombreDispositivo"
                    value={values.NombreDispositivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    useGrouping={false}
                    className={error.NombreDispositivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreDispositivo">Nombre Dispositivo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor3 gap-2">
                <div className="field col-4">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"TipoDispositivo"}
                        value={values.TipoDispositivo}
                        items={tipoDispositivos}
                        field={"TipoDispositivo"}
                        label={"Tipo Dispositivo"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdTipoDispositivo ? "p-invalid" : ""}
                    />
                    </span>
                </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoRedes"}
                    value={values.TipoRedes}
                    items={tipoRed}
                    field={"NombreDescripcion"}
                    label={"Tipo Red"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdTipoRed ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"ClaseRed"}
                    value={values.ClaseRed}
                    items={claseRed}
                    field={"ClaseRango"}
                    label={"Clase"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdClase ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor3 gap-2">
                <div className="field col-4">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"Marcas"}
                        value={values.Marcas}
                        items={marcas}
                        field={"Marca"}
                        label={"Marca"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdMarca ? "p-invalid" : ""}
                    />
                    </span>
                </div>

                <div className="field col-4">
                    <span className="p-float-label">
                    <InputText
                        name="Modelo"
                        value={values.Modelo}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.Modelo ? "p-invalid" : ""}
                    />
                    <label htmlFor="Modelo">Módelo</label>
                    </span>
                </div>


                <div className="field col-4">
                    <span className="p-float-label">
                    <InputText
                        name="Serie"
                        value={values.Serie}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.Serie ? "p-invalid" : ""}
                    />
                    <label htmlFor="Serie">Serie</label>
                    </span>
                </div>
            </div>

            <div className="modal__input-contenedor3 gap-2">

                <div className="field col-4">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"Areas"}
                        value={values.Areas}
                        items={areas}
                        field={"Area"}
                        label={"Area"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdArea ? "p-invalid" : ""}
                    />
                    </span>
                </div>

                <div className="field col-4">
                    <span className="p-float-label">
                    <InputText
                        name="AnyDesk"
                        value={values.AnyDesk}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.AnyDesk ? "p-invalid" : ""}
                    />
                    <label htmlFor="AnyDesk">AnyDesk</label>
                    </span>
                </div>

                <div className="field col-4">
                    <span className="p-float-label">
                    <InputText
                        name="ClaveAnydesk"
                        value={values.ClaveAnydesk}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.ClaveAnydesk ? "p-invalid" : ""}
                    />
                    <label htmlFor="ClaveAnydesk">Clave AnyDesk</label>
                    </span>
                </div>

            </div>

            <div className="modal__input-contenedor3 gap-2">

                <div className="field col-4">
                    <span className="p-float-label">
                    <AutoCompleteDropdown
                        name={"PersonalD"}
                        value={values.PersonalD}
                        items={personal}
                        field={"NombreEmpleado"}
                        label={"Asignado a"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdArea ? "p-invalid" : ""}
                    />
                    </span>
                </div>

                <div className="field col-8">
                    <span className="p-float-label">
                    <InputText
                        name="Comentarios"
                        value={values.Comentarios}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        labelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                        }}
                        className={error.Comentarios ? "p-invalid" : ""}
                    />
                    <label htmlFor="Comentarios">Comentario</label>
                    </span>
                </div>

            </div>

            <div className="modal__input-contenedor3 gap-2">
              <div className="field col-8">
                <span className="p-float-label">
                  <Chips
                    name='Correos'
                    value={values?.Correos}
                    onChange={handleInputChange}
                    style={{width:'100%'}}
                    className="chips-full"
                  />
                  <label htmlFor="Comentarios">Correos</label>
                </span>
              </div>

              <div className="field col-4">
                <div className="flex align-items-center">
                    <Checkbox
                      inputId="UsaAntivirus"
                      name="UsaAntivirus"
                      onChange={(e) =>
                        setValues({ ...values, UsaAntivirus: e.checked })
                      }
                      checked={values.UsaAntivirus}
                    />
                    <label htmlFor="UsaAntivirus" className="mx-2">Usa Antivirus</label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RedCRUD;
